import {
  type InferOutput,
  literal,
  nonEmpty,
  object,
  pipe,
  string,
  trim,
  union,
  url,
} from "valibot";

export const EmailBisonCustomUrlSchema = object({
  custom_url: union([
    literal(""),
    pipe(
      string(),
      trim(),
      url("Enter a valid URL format (e.g., https://mail.yourdomain.com)"),
    ),
  ]),
});

export type EmailBisonCustomUrlSchemaType = InferOutput<
  typeof EmailBisonCustomUrlSchema
>;

export const IntegrationApiKeySchema = object({
  api_key: pipe(string(), trim(), nonEmpty("API key is required")),
  ...EmailBisonCustomUrlSchema.entries,
});

export type IntegrationApiKeySchemaType = InferOutput<
  typeof IntegrationApiKeySchema
>;
